import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, PhoneCall, Users } from 'lucide-react';
const WhyChooseUs = () => {
  return <section className="py-16 bg-white" data-id="element-98">
      <div className="container mx-auto px-4" data-id="element-99">
        <div className="text-center mb-12" data-id="element-100">
          <h2 className="text-3xl font-bold text-mwc-burgundy mb-4" data-id="element-101">
            Why Thousands Choose Our Services
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-102">
            At Maplewood-Care, we have successfully repaired and maintained over
            300,000 appliances across the UK, making us one of the fastest
            growing appliance repair service providers.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-103">
          <div className="bg-mwc-lightpink p-6 rounded-lg shadow-sm" data-id="element-104">
            <div className="text-mwc-burgundy mb-4" data-id="element-105">
              <Shield size={48} data-id="element-106" />
            </div>
            <h3 className="text-xl font-bold text-mwc-burgundy mb-3" data-id="element-107">
              Transparent Pricing, Quality Workmanship
            </h3>
            <p className="text-gray-700" data-id="element-108">
              We provide professional repair services for your essential
              household appliances with transparent, straightforward pricing.
              All parts and labour costs are clearly communicated before work
              begins.
            </p>
          </div>
          <div className="bg-mwc-lightpink p-6 rounded-lg shadow-sm" data-id="element-109">
            <div className="text-mwc-burgundy mb-4" data-id="element-110">
              <PhoneCall size={48} data-id="element-111" />
            </div>
            <h3 className="text-xl font-bold text-mwc-burgundy mb-3" data-id="element-112">
              One Call, Prompt Service
            </h3>
            <p className="text-gray-700" data-id="element-113">
              When an appliance breaks down, simply contact us and we arrange
              everything. Our dedicated team organises your repair visit
              promptly, dispatching qualified engineers to your home
              efficiently.
            </p>
          </div>
          <div className="bg-mwc-lightpink p-6 rounded-lg shadow-sm" data-id="element-114">
            <div className="text-mwc-burgundy mb-4" data-id="element-115">
              <Users size={48} data-id="element-116" />
            </div>
            <h3 className="text-xl font-bold text-mwc-burgundy mb-3" data-id="element-117">
              Expert Technical Support
            </h3>
            <p className="text-gray-700" data-id="element-118">
              Our customers benefit from direct access to technical assistance
              whenever needed. Whether you require diagnostics advice or
              troubleshooting guidance, our knowledgeable support team is ready
              to help.
            </p>
          </div>
        </div>
        <div className="mt-16 flex justify-center" data-id="element-119">
          <div className="max-w-3xl bg-mwc-lightpink p-8 rounded-lg border border-mwc-pink flex items-center" data-id="element-120">
            <div className="mr-8 hidden md:block" data-id="element-121">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1rRfBYkZptQjN7eochUGQb/Maplewood_staff_fixing_Dishwasher_2.jpg" alt="Maplewood Care Engineer Fixing Dishwasher" className="w-48 h-auto object-cover rounded-md" data-id="element-122" />
            </div>
            <div data-id="element-123">
              <h3 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-124">
                Reliable Service for Your Home
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-125">
                Our customers trust us because we deliver professional
                workmanship, reliable service, and straightforward communication
                at every step. With Maplewood-Care, you can be confident that
                your essential appliances receive expert attention.
              </p>
              <Link to="/contact-us" className="inline-block bg-mwc-burgundy hover:bg-mwc-darkburgundy text-white font-semibold px-6 py-3 rounded-md transition-colors duration-300" data-id="element-126">
                Book a Repair Today
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default WhyChooseUs;